import { useQuery } from '@tanstack/react-query';
import formatReportHistory from '../../../utils/formatReportHistory';
import formatHistoryDataWs from '../../../utils/formatHistoryDataWs';
import fetchSRS from '../../../utils/fetchSRS';
import sportsApi from '../../../utils/sportsApi';

const useFetchReports = ({
    pptReporting = false,
    clientId,
    limit,
}: {
    pptReporting?: boolean;
    clientId: number;
    limit?: number;
}) => {
    const fetchReportsData = async () => {
        let historyData = [];

        if (!pptReporting) {
            const rawHistory = await sportsApi
                .url(`/clients/${clientId}/mvc-reports`)
                .get();
            const history: any[] = await rawHistory.json();

            historyData = history.reduce((acc, data) => {
                acc.push(formatReportHistory(data));
                return acc;
            }, []);
            return historyData;
        } else {
            const params = new URLSearchParams();
            if (limit) {
                params.append('limit', limit.toString());
            }

            const records = await fetchSRS
                .url(`/reports?${params.toString()}`)
                .get()
                .json();

            historyData = (Array.isArray(records) ? records : [])
                .reduce((acc, rec) => {
                    const { isArchived } = rec;
                    if (isArchived) return acc;
                    const row = formatHistoryDataWs(rec);
                    acc.push(row);
                    return acc;
                }, [])
                .sort(
                    (a, b) =>
                        new Date(b.addedAt).getTime() -
                        new Date(a.addedAt).getTime(),
                );

            return historyData;
        }
    };

    const { data, isLoading, isError, refetch } = useQuery({
        queryKey: ['historyData', clientId, pptReporting, limit],
        queryFn: fetchReportsData,
    });

    return { data, isLoading, isError, refetch };
};

export default useFetchReports;
